"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetEnvironmentProductFiles = void 0;
var _productsList = require("../products/models/prod/productsList");
var _publicProductsExporter = require("../products/models/prod/publicProductsExporter");
var _staffProductsExporter = require("../products/models/prod/staffProductsExporter");
var _productsList2 = require("../products/models/preprod/productsList");
var _publicProductsExporter2 = require("../products/models/preprod/publicProductsExporter");
var _staffProductsExporter2 = require("../products/models/preprod/staffProductsExporter");
var _productsList3 = require("../products/models/uat/productsList");
var _publicProductsExporter3 = require("../products/models/uat/publicProductsExporter");
var _staffProductsExporter3 = require("../products/models/uat/staffProductsExporter");
var _productsList4 = require("../products/models/sit/productsList");
var _publicProductsExporter4 = require("../products/models/sit/publicProductsExporter");
var _staffProductsExporter4 = require("../products/models/sit/staffProductsExporter");
var GetEnvironmentProductFiles = exports.GetEnvironmentProductFiles = function GetEnvironmentProductFiles(env) {
  switch (env) {
    case 'uat':
      return {
        productList: _productsList3.ProductList,
        publicProducts: _publicProductsExporter3.AllPublicProducts,
        staffProducts: _staffProductsExporter3.AllStaffProducts
      };
    case 'sit':
      return {
        productList: _productsList4.ProductList,
        publicProducts: _publicProductsExporter4.AllPublicProducts,
        staffProducts: _staffProductsExporter4.AllStaffProducts
      };
    case 'preprod':
      return {
        productList: _productsList2.ProductList,
        publicProducts: _publicProductsExporter2.AllPublicProducts,
        staffProducts: _staffProductsExporter2.AllStaffProducts
      };
    case 'prod':
    default:
      return {
        productList: _productsList.ProductList,
        publicProducts: _publicProductsExporter.AllPublicProducts,
        staffProducts: _staffProductsExporter.AllStaffProducts
      };
  }
};